module.exports = __webpack_public_path__ + "static/media/dok_f_thumb_even.688578a6.jpg";